<template>
  <div class="ma-6">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
      <v-row>
        <v-col cols="12" lg="2" md="2">
          <div class="borderkotak">
            <div class="ma-2 justify-center text-center"><h3>Kategori Produk</h3></div>
            <v-list>
              <v-list-group  v-for="(item, index) in category"
                             :href="item.href"
                             :key="index">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item dense
                  v-for="child in item.brands"
                  :key="child.id"
                >
                  <v-list-item-content>
                    <v-list-item-title style="cursor: pointer" @click="changeBrand(child.id)" v-text="child.brandname"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list>
          </div>
        </v-col>
        <v-col cols="12" lg="10" md="10">
          <div class="borderkotak">
            <v-row class="pr-4 pl-4">
              <div class="filterproduklist">
                <div class="mt-6">
                  <v-select
                    label="Urutkan Harga"
                    item-text="label"
                    item-value="id"
                    v-model="opsitable.sortharga"
                    :items="sortHarga"
                    @change="changesortharga"
                  ></v-select>
                </div>
              </div>
              <div class="filterproduklist">
                <div class="mt-6 ml-2">
                  <v-select
                    label="Produk"
                    item-text="productname"
                    item-value="id"
                    v-model="productid"
                    :items="product"
                    @change="changeProduk"
                  ></v-select>
                </div>
              </div>
            </v-row>
            <v-divider/>
            <div class="productlist">
              <v-layout row wrap class="mt-2 pa-4">
                <v-flex lg2  sm6 xs12 v-for="(item, index) in productpricing"  :key="index">
                  <v-card class="ma-2" elevation="1">
                    <div v-if="item.discount>0" class="tagpromo"><span>Promo</span></div>
                    <v-card-text  class="align-center align-content-center mt-3 text-center center-pill align-content-center">
                      <div class="text-center"><h3>{{formatAngka(item.price)}}</h3></div>
                      <div class="text-center">{{item.productname}}</div>
                      <img alt="logoprod" class="imageproduct" style="" width="100px" height="100px" :src="item.brandlogo"/>
                      <div>{{hurupcapital(item.productcode)}}</div>
                      <v-btn class="primary" dark outlined @click="tambahprodukmapping(item)">Tambah</v-btn>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions style="cursor: pointer" @click="gosellerpage(item.sellerid)">
                      <v-icon>store</v-icon> {{potongnama(item.sellername)}}
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-col>
      </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import S from 'string'
import Utils from '@/plugins/utils'

export default {
  name: 'Product',
  data: () => ({
    sortHarga: [
      {
        id: 0,
        label: 'Paling Mahal'
      },
      {
        id: 1,
        label: 'Paling Murah'
      }
    ],
    productid: 0,
    opsitable: {
      sortharga: 0
    }
  }),
  mounted () {
    if (this.caribrandid) {
      localStorage.setItem('productview_brandid', this.caribrandid)
      this.getProducByBrandId(this.caribrandid)
      this.getProducPricingByBrandId(this.caribrandid)
    }
  },
  computed: {
    ...mapState('ProductStore', ['category', 'product', 'productpricing', 'overlay', 'loading']),
    caribrandid () {
      return this.$route.query.brandid
    }
  },
  methods: {
    ...mapActions('ProductStore', ['getProducByBrandId', 'getProducPricingByProductId', 'getProducPricingByBrandId']),
    ...mapActions('ProductMapping', ['addProductmapping']),
    changesortharga (val) {
      console.log(val)
      localStorage.setItem('sortpriceproduk', val)
      this.getProducPricingByProductId(localStorage.getItem('productview_productid'))
    },
    changeProduk (val) {
      localStorage.setItem('productview_productid', val)
      this.getProducPricingByProductId(val)
    },
    changeBrand (val) {
      localStorage.setItem('productview_brandid', val)
      this.getProducByBrandId(val)
      this.getProducPricingByBrandId(val)
    },
    gosellerpage (id) {
      this.$router.push('/supplier/' + id)
    },
    potongnama (val) {
      if (val.length > 15) {
        return S(val).left(15).replaceAll('`', '').replaceAll("'", '').s
      } else {
        return val.toUpperCase()
      }
    },
    hurupcapital (val) {
      return val.toUpperCase()
    },
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    tambahprodukmapping (item) {
      console.log(item)
      localStorage.setItem('productview_productid', item.productid)
      this.$confirm('Yakin akan Tambahkan ' + item.productname + ' ke ' + item.sellername, { color: 'green', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          var a = {
            productmemberid: item.id,
            status: 1,
            prioritas: 0,
            sellerid: item.sellerid
          }
          this.addProductmapping(a)
        }
      })
    }
  }
}
</script>

<style scoped>

.borderkotak {
  border: thin solid rgba(0,0,0,.12)
}

.imageproduct {
  position: relative;
}

.tagpromo {
  position: absolute;
  left: -2px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}

.tagpromo span {
  font-size: 9px;
  font-weight: bold;
  color: #ffffff;
  text-transform: uppercase;
  text-align: center;
  line-height: 17px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  width: 83px;
  display: block;
  box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);
  background: #79A70A;
  background: linear-gradient(green 0%, green 100%);
  /* background: linear-gradient(#3bafda 0%, #3bafda 100%); */
  position: absolute;
  top: 9px;
  left: -24px;
}

.tagpromo span:before {
  content: "";
  position: absolute;
  left: 0px;
  top: 100%;
  z-index: -1;
  border-left: 3px solid green;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid green;
}
.tagpromo span:after {
  content: "";
  position: absolute;
  right: 0px;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid green;
  border-bottom: 3px solid transparent;
  border-top: 3px solid green;
}
</style>
